import { render, staticRenderFns } from "./DetalleDespachoHarina.vue?vue&type=template&id=0a48cc4a&scoped=true&"
import script from "./DetalleDespachoHarina.vue?vue&type=script&lang=js&"
export * from "./DetalleDespachoHarina.vue?vue&type=script&lang=js&"
import style0 from "./DetalleDespachoHarina.vue?vue&type=style&index=0&id=0a48cc4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a48cc4a",
  null
  
)

export default component.exports